import throttle from 'lodash/throttle';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { getDocBeforeUnconfirmedSteps } from '@atlaskit/prosemirror-collab';
import type { Step } from '@atlaskit/editor-prosemirror/transform';

import type { StepsDatabase } from '../stepsDatabase.ts';

import { editorOfflineStoragePluginKey } from './main.ts';

type StoreUnconfirmedStepsProps = {
	editorView: EditorView;
	stepsDatabase: StepsDatabase;
	version: number;
	steps: readonly Step[];
	broadcast: () => void;
};

export const syncWithOfflineStorageUnthrottled = async ({
	editorView,
	stepsDatabase,
	version,
	steps,
	broadcast,
}: StoreUnconfirmedStepsProps): Promise<void> => {
	const baseDocJSON = getDocBeforeUnconfirmedSteps(editorView.state).toJSON();

	const hasChanged = await stepsDatabase.updateIfChanged(version, baseDocJSON, steps);

	if (hasChanged) {
		broadcast();
	} else {
		editorView.dispatch(
			editorView.state.tr.setMeta(editorOfflineStoragePluginKey, {
				disabled: 'unableToSync',
			}),
		);
	}
};

const syncWithOfflineStorageImpl = throttle(syncWithOfflineStorageUnthrottled, 200);

export const syncWithOfflineStorage: typeof syncWithOfflineStorageImpl = syncWithOfflineStorageImpl;
